// extracted by mini-css-extract-plugin
module.exports = {"geosuggest-popup":"aee5b7c44e--geosuggest-popup--j8epB","suggestion-list":"aee5b7c44e--suggestion-list--NRzbC"};